export const staircaseConfig = {
    gameSlug: 'faux-pas-detection',
    category: 'lumiere_emotions',
    variable: 'item_rank',
    startValue: 2,
    minValue: 1,
    maxValue: 5,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 12,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, mode: 'guided', label: 'Initiation' };
    }
    if (level <= 20) {
        return { level, mode: 'guided', label: 'Détection' };
    }
    if (level <= 30) {
        return { level, mode: 'autonomous', label: 'Sans béquille' };
    }
    if (level <= 40) {
        return { level, mode: 'autonomous', label: 'Subtilité' };
    }
    return { level, mode: 'autonomous', label: 'Lecture experte' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase. */
export const timing = {
    /** Temps minimum de lecture forcé avant que le bouton « Lu » s'active. */
    readingMinMs: 2500,
    /** Durée affichage feedback éducatif (plus longue que la moyenne). */
    feedbackMs: 3000,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: 'faux-pas-detection',
    paradigm: 'Faux Pas Recognition Test (Stone, Baron-Cohen & Knight 1998)',
    masterMage: 'Sole (lumière-émotions)',
    category: 'lumiere_emotions',
    goal: 'Lecture sociale fine : leadership, parentalité, médecine, vente.',
};
//# sourceMappingURL=params.js.map